<template>
  <fieldset>
    <FormulateInput
      name="reasonofterminationquality"
      :options="{
        qualityofcare: i18n.form.labels.reasonofterminationqualityoptions.qualityofcare,
        location: i18n.form.labels.reasonofterminationqualityoptions.location,
        employees: i18n.form.labels.reasonofterminationqualityoptions.employees,
        activities: i18n.form.labels.reasonofterminationqualityoptions.activities,
        other: i18n.form.labels.reasonofterminationqualityoptions.other,
      }"
      type="radio"
      :label="i18n.form.labels.reasonofterminationquality"
      validation="required"
      :validation-messages="i18n.form.validations.reasonofterminationquality"
    />
    <FormulateInput
      v-if="showReasonInput"
      name="reasonofterminationqualityotherreason"
      type="textarea"
      validation="bail|required|nohtml"
      :validation-messages="i18n.form.validations.reasonofterminationqualityotherreason"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsReasonOfTerminationQuality',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showReasonInput() {
      return this.model.reasonofterminationquality === 'other';
    },
  },
};
</script>
